export default "__VITE_ASSET__aFsucuIW__"